import React from 'react';

const STATUS_MAP = { todo: 'À faire', 'in-progress': 'En cours', done: 'Terminée' };
const PRI_MAP    = { low: 'Faible', medium: 'Moyenne', high: 'Haute' };

function dueInfo(dateStr, isDone) {
  if (!dateStr) return null;
  const due  = new Date(dateStr);
  const now  = new Date();
  const diff = Math.ceil((due - now) / 86400000);
  const fmt  = due.toLocaleDateString('fr-FR', { day:'2-digit', month:'short' });
  if (isDone) return { label: fmt, cls: '' };
  if (diff < 0) return { label: `En retard (${fmt})`, cls: 'overdue' };
  if (diff <= 2) return { label: `⚠️ ${fmt}`, cls: 'soon' };
  return { label: `📅 ${fmt}`, cls: '' };
}

export default function TaskCard({ task, onEdit, onDelete, onToggle, listView }) {
  const isDone = task.status === 'done';
  const due    = dueInfo(task.dueDate, isDone);

  return (
    <div className={`task-card priority-${task.priority} ${isDone ? 'done-card' : ''} ${listView ? 'list-card' : ''}`}>
      <div className="task-header">
        <button className={`done-toggle ${isDone ? 'checked' : ''}`} onClick={() => onToggle(task)} title="Changer le statut">
          {isDone ? '✓' : ''}
        </button>
        <span className="task-title">{task.title}</span>
        <div className="task-actions">
          <button className="task-action-btn" onClick={() => onEdit(task)} title="Modifier">✏️</button>
          <button className="task-action-btn delete" onClick={() => onDelete(task._id)} title="Supprimer">🗑</button>
        </div>
      </div>

      {task.description && !listView && (
        <p className="task-description">{task.description}</p>
      )}

      <div className="task-meta">
        <span className={`badge badge-${task.status === 'in-progress' ? 'in-progress' : task.status}`}>
          {STATUS_MAP[task.status]}
        </span>
        <span className={`badge badge-${task.priority}`}>{PRI_MAP[task.priority]}</span>
        <span className="badge badge-category">{task.category}</span>
        {due && <span className={`task-due ${due.cls}`}>{due.label}</span>}
      </div>

      {task.tags?.length > 0 && !listView && (
        <div className="tags-row">
          {task.tags.map((t, i) => <span key={i} className="tag">#{t}</span>)}
        </div>
      )}
    </div>
  );
}
